/**
 * Create Job Button
 *
 * Button to open the Create Job modal.
 * Only visible for dispatcher+ roles.
 *
 * DDD Compliance:
 * - Purely presentational component
 * - Role checking handled by parent or auth context
 * - Opens modal when clicked
 */

import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { CreateJobModal } from './CreateJobModal';

interface CreateJobButtonProps {
  /**
   * Optional: Function to determine if user has dispatcher+ permissions
   * For now, we'll default to true since role system isn't fully implemented
   */
  canCreate?: boolean;
}

export function CreateJobButton({ canCreate = true }: CreateJobButtonProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Don't render if user doesn't have permission
  if (!canCreate) {
    return null;
  }

  return (
    <>
      <Button
        onClick={() => setIsModalOpen(true)}
        variant="default"
        className="whitespace-nowrap"
      >
        <svg
          className="w-5 h-5 mr-2"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 4v16m8-8H4"
          />
        </svg>
        Create Job
      </Button>

      {isModalOpen && (
        <CreateJobModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </>
  );
}
